import React from 'react'
import { Link } from 'react-router-dom'
import mobileLogo from './mobileLogo.webp'
import newlogo from './newlogo.png'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    logo: {
        textDecoration: 'none',
        display: "flex",
        flexDirection: 'row',
        justifyContent: "center",
        alignItems: "center",
        flexWrap: 'noWrap',
        cursor: "pointer",
        paddingRight: '10px'
    },
    bigLogo: {
        display: 'inline',
        [theme.breakpoints.only('xs')]: {
            display: 'none'
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            display: 'none'
        },
    },
    smallLogo: {
        display: 'none',
        [theme.breakpoints.between('xs', 'sm')]: {
            display: 'inline'
        },
        [theme.breakpoints.only("xs")]: {
            display: 'inline'
        },

    }
}));


const HelpWidget = (props) => {
    const classes = useStyles()
    return (
        <React.Fragment>
            <Link to="/" className={`${classes.logo} ${classes.bigLogo}`} >
                <img src={newlogo} height="60px" alt="DESI COOKS LOGO" />
            </Link>
            <Link to="/" className={`${classes.logo} ${classes.smallLogo}`}>
                <img src={mobileLogo} height="40px" alt="DESI COOKS LOGO" />
            </Link>
        </React.Fragment >
    )

}

export default HelpWidget